import { z } from "zod";

function extractJsonText(content: string): string | null {
    const trimmed = content.trim();
    if (!trimmed) return null;

    const fenceMatch = trimmed.match(/^```(?:json)?\s*([\s\S]*?)```$/im);
    let jsonText = fenceMatch?.[1]?.trim() ?? trimmed;

    if (!fenceMatch) {
        const firstBrace = jsonText.indexOf("{");
        const firstBracket = jsonText.indexOf("[");
        const start =
            firstBrace === -1 ? firstBracket : firstBracket === -1 ? firstBrace : Math.min(firstBrace, firstBracket);
        if (start === -1) return null;
        const closer = jsonText[start] === "[" ? "]" : "}";
        const end = jsonText.lastIndexOf(closer);
        if (end <= start) return null;
        jsonText = jsonText.slice(start, end + 1);
    }

    return jsonText;
}

/** Best-effort JSON from an LLM response. Returns undefined when it is not valid JSON. */
export function tryParseJsonFromLlmContent(content: string): unknown {
    const jsonText = extractJsonText(content);
    if (!jsonText) return undefined;
    try {
        return JSON.parse(jsonText) as unknown;
    } catch {
        return undefined;
    }
}

/** Parse JSON from an LLM response, stripping optional markdown fences or surrounding prose. */
export function parseJsonFromLlmContent<T>(content: string, schema: z.ZodType<T>): T {
    const parsed = tryParseJsonFromLlmContent(content);
    if (parsed === undefined) {
        throw new Error("AI returned text that was not valid JSON.");
    }
    return schema.parse(parsed);
}
